import { makeStyles } from '@material-ui/core/styles';
import ProductImageDecorated from '@sprinx/react-com/ProductImageDecorated';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { CatalogueProduct } from '../../../api/products/catalogue';
import useProductAdornmentsMapper from '../../../api/products/useProductAdornmentsMapper';
import ProductDetailLink from '../../../components/ProductDetailLink';
import useProductUrl from '../../../hooks/useProductUrl';
import useTranslateWithFallback from '../../../hooks/useTranslateWithFallback';

export interface CataloguePageListContentItemRowImageProps
  extends StandardDivProps<CataloguePageListContentItemRowImageClassKey> {
  product: Pick<CatalogueProduct, 'id' | 'adornments' | 'image' | 'name' | 'taxonomies'>;
}

export type CataloguePageListContentItemRowImageClassKey = 'root' | 'image';

const themeSettings = { name: 'CataloguePageListContentItemRowImage' };
const useStyles = makeStyles(
  (theme) => ({
    root: {},
    image: {
      '& > div': {
        width: theme.spacing(12),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
          paddingRight: 0,
          marginBottom: theme.spacing(1),
        },
      },
      '& img': { width: theme.spacing(12) },
    },
    linkText: {
      display: 'none',
    },
  }),
  themeSettings,
);

const CataloguePageListContentItemRowImage = React.forwardRef<
  HTMLDivElement,
  CataloguePageListContentItemRowImageProps
>(({ className, classes: pClasses, product, ...rest }, ref) => {
  const classes = useStyles({ classes: pClasses });
  const imageAdornments = useProductAdornmentsMapper('row', product.adornments, product);
  const to = useProductUrl(product);
  const t = useTranslateWithFallback();

  return (
    <div ref={ref} className={clsx(classes.root, className)} {...rest}>
      <ProductDetailLink to={to}>
        <ProductImageDecorated
          {...imageAdornments}
          src={product.image as any}
          alt={t(product.name)}
          size='normal'
          type='image'
          classes={{ root: classes.image }}
        />
      </ProductDetailLink>
    </div>
  );
});

CataloguePageListContentItemRowImage.displayName = 'CataloguePageListContentItemRowImage';

export default withThemeProps(themeSettings)(CataloguePageListContentItemRowImage);
